import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import { FiltersMenu, FiltersSubMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconWorld from '@/icons/World.svg';
import { TYPES } from '@/models/entity';

import { useFilters } from '../FiltersState';

export const FiltersType = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    types: { types, setTypes },
  } = useFilters();

  const options = TYPES.map(({ id, label }) => (
    <FilterCheckboxItem
      key={id}
      checked={types.includes(id)}
      onChange={(checked) => {
        if (checked) {
          setTypes([...types, id]);
        } else {
          setTypes(types.filter((type) => type !== id));
        }
      }}
    >
      {i18n._(label)}
    </FilterCheckboxItem>
  ));

  if (tag) {
    if (types.length === 0) {
      return null;
    }

    const numberOfTypes = types.length;

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({
              id: 'settings.organization.entities.entities.filters.type.label',
              message: 'Type',
            })}
            value={
              types.length === 1 ? (
                i18n._(TYPES.find((type) => type.id === types[0])!.label)
              ) : (
                <Trans id="settings.organization.entities.entities.filters.type.multiple">
                  {numberOfTypes} types
                </Trans>
              )
            }
            tooltip={
              types.length > 1
                ? types.map((type) => i18n._(TYPES.find((st) => st.id === type)!.label)).join(', ')
                : undefined
            }
            onClear={() => setTypes([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconWorld />}
      label={t({
        id: 'settings.organization.entities.entities.filters.type.label',
        message: 'Type',
      })}
    >
      {options}
    </FiltersSubMenu>
  );
};
